<ph-dialog [open]="open" size="xl" [heading]="vendorId ? 'Edit vendor' : 'Add vendor'" (ph-close)="close()">
    <app-vendor-editor *ngIf="open"
                       #vendorEditor
                       [vendorId]="vendorId"
                       [embedded]="true"
                       (saved)="closeSaved($event)"></app-vendor-editor>

    <ph-actions slot="footer">
        <ph-button variant="secondary" mode="filled" (click)="close()">Cancel</ph-button>
        <ph-button [disabled]="isSaving" (click)="saveVendor()">Save vendor</ph-button>
    </ph-actions>
</ph-dialog>
